export const deleteSpacesInString = (str: string) => {
    if(str.search(/\d/ ) !== -1) {
        return str.replace(/\s/g, '').trim();
    }
   return str;
};
